import React, { useState, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Autocomplete,
  Card,
  CardContent,
  Divider,
  CircularProgress,
  Chip,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Calculate, Refresh, Settings, Edit, Delete, Add, Save, Cancel, RestartAlt, PictureAsPdf, Code, AddCircleOutline } from "@mui/icons-material";
import { FaX } from "react-icons/fa6";
import { useAuth } from "../login/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import config from "../../config/config";
import FiyatHesaplamaWizard from "./wizard/FiyatHesaplamaWizard";
import "./FiyatHesaplama.css";

const FiyatHesaplama = () => {
  const { token, userData } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0); // 0: Hesaplama, 1: Fiyat Yönetimi
  
  // Fiyat Yönetimi ve Komisyon Yönetimi için sadece BayiId/BayiKodu === 1 olanlar
  const isFiyatYonetimiYetkisi = userData?.BayiKodu === 1 || userData?.BayiId === 1;
  const isKomisyonYetkisi = userData?.BayiKodu === 1 || userData?.BayiId === 1;
  const [calculating, setCalculating] = useState(false);
  const [paketler, setPaketler] = useState([]);
  const [moduller, setModuller] = useState([]);
  const [fiyatlar, setFiyatlar] = useState(null);
  const [selectedPaket, setSelectedPaket] = useState("");
  const [selectedPaketData, setSelectedPaketData] = useState(null); // Seçilen paketin tüm bilgileri
  const [availableModules, setAvailableModules] = useState([]);
  const [selectedModules, setSelectedModules] = useState([]);
  const [kullaniciSayisi, setKullaniciSayisi] = useState(1);
  const [paketIskontoOrani, setPaketIskontoOrani] = useState(0);
  const [modulIskontoOrani, setModulIskontoOrani] = useState(0);
  const [ekKullaniciIskontoOrani, setEkKullaniciIskontoOrani] = useState(0);
  const [bulutSunucu, setBulutSunucu] = useState(false);
  const [onlineBankaPaket, setOnlineBankaPaket] = useState("");
  const [hesaplamaSonucu, setHesaplamaSonucu] = useState(null);
  const [pdfIndirLoading, setPdfIndirLoading] = useState(false);
  const [xmlIndirLoading, setXmlIndirLoading] = useState(false);
  const [bosPdfIndirLoading, setBosPdfIndirLoading] = useState(false);
  const [cariDialogOpen, setCariDialogOpen] = useState(false);
  /** Yazdırma: yeni sekme açmadan mevcut sayfada print-only alan ile yazdırılır */
  const [printBodyHtml, setPrintBodyHtml] = useState(null);
  const [printCssText, setPrintCssText] = useState("");
  // Teklif: cari/müşteri seçimi adımları
  const [teklifCariKaynagi, setTeklifCariKaynagi] = useState("potansiyel"); // potansiyel | musteri (dialog)
  const [teklifTipi, setTeklifTipi] = useState("yeniTeklif"); // yeniTeklif | yillikYenileme (ana ekran seçimi)
  const [musteriQuery, setMusteriQuery] = useState("");
  const [musteriOptions, setMusteriOptions] = useState([]);
  const [musteriLoading, setMusteriLoading] = useState(false);
  const [selectedMusteri, setSelectedMusteri] = useState(null);
  // Yıllık yenileme: ana ekranda müşteri seçimi
  const [yenilemeMusteriQuery, setYenilemeMusteriQuery] = useState("");
  const [yenilemeMusteriOptions, setYenilemeMusteriOptions] = useState([]);
  const [yenilemeSelectedMusteri, setYenilemeSelectedMusteri] = useState(null);
  const [yenilemeMusteriLoading, setYenilemeMusteriLoading] = useState(false);
  const [yenilemeHesaplaLoading, setYenilemeHesaplaLoading] = useState(false);
  const [yenilemeLisanslar, setYenilemeLisanslar] = useState([]);
  const [yenilemeSelectedLisansId, setYenilemeSelectedLisansId] = useState(null);
  const bosCariForm = {
    unvan: "",
    vergiDairesi: "",
    vergiNo: "",
    tcKimlikNo: "",
    adi: "",
    soyadi: "",
    email: "",
    telefon: "",
    adresFatura: "",
  };
  const [cariForm, setCariForm] = useState({ ...bosCariForm });
  const [ekstraSatirlar, setEkstraSatirlar] = useState([]); // [{ id, aciklama, miktar, birimFiyat, iskontoOrani }]
  const [paketDetayList, setPaketDetayList] = useState([]);
  const [wizardKey, setWizardKey] = useState(0);

  // Fiyat Yönetimi state'leri
  const [fiyatListesi, setFiyatListesi] = useState([]);
  const [fiyatLoading, setFiyatLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingFiyat, setEditingFiyat] = useState(null);
  const [formData, setFormData] = useState({
    FiyatTipi: "",
    ReferansId: "",
    Fiyat: "",
    Aciklama: "",
    Etkin: true,
  });

  // Bayi fiyat override (aynı satırda iskonto yanında - önerilen sabit fiyat, değiştirilebilir)
  const [overridePaketFiyat, setOverridePaketFiyat] = useState("");
  const [overrideModulFiyat, setOverrideModulFiyat] = useState({});
  const [overrideEkKullaniciToplam, setOverrideEkKullaniciToplam] = useState("");
  const [overrideEFaturaEIrsaliyeBirlikte, setOverrideEFaturaEIrsaliyeBirlikte] = useState("");

  // Komisyon Yönetimi state'leri
  const [komisyonGrid, setKomisyonGrid] = useState({});
  const [komisyonLoading, setKomisyonLoading] = useState(false);
  const [komisyonSaving, setKomisyonSaving] = useState(false);
  const [bayiKazanc, setBayiKazanc] = useState(null);

  const fetchKomisyonOranlari = useCallback(async () => {
    if (!isKomisyonYetkisi) return;
    try {
      setKomisyonLoading(true);
      const res = await axios.get(`${config.baseURL}/fiyatlar/komisyon`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data?.success && res.data.data?.grid) {
        setKomisyonGrid(res.data.data.grid);
      }
    } catch (e) {
      console.error("Komisyon oranları:", e);
      toast.error("Komisyon oranları yüklenemedi");
    } finally {
      setKomisyonLoading(false);
    }
  }, [isKomisyonYetkisi, token]);

  const saveKomisyonOranlari = useCallback(async () => {
    try {
      setKomisyonSaving(true);
      await axios.put(
        `${config.baseURL}/fiyatlar/komisyon`,
        { grid: komisyonGrid },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Komisyon oranları kaydedildi");
    } catch (e) {
      console.error("Komisyon kaydet:", e);
      toast.error(e?.response?.data?.message || "Kaydetme başarısız");
    } finally {
      setKomisyonSaving(false);
    }
  }, [komisyonGrid, token]);

  const fetchBayiKazanc = useCallback(async () => {
    if (!hesaplamaSonucu) {
      setBayiKazanc(null);
      return;
    }
    try {
      const res = await axios.post(
        `${config.baseURL}/fiyatlar/komisyon/bayi-kazanc`,
        {
          hesaplamaSonucu,
          ekstraSatirlar: ekstraSatirlar
            .filter((s) => s.aciklama && (Number(s.birimFiyat) || 0) >= 0)
            .map((s) => ({
              aciklama: s.aciklama,
              miktar: Number(s.miktar) || 1,
              birimFiyat: Number(s.birimFiyat) || 0,
              iskontoOrani: Number(s.iskontoOrani) || 0,
            })),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data?.success) setBayiKazanc(res.data.data);
      else setBayiKazanc(null);
    } catch (e) {
      console.error("Bayi kazanç:", e);
      setBayiKazanc(null);
    }
  }, [hesaplamaSonucu, ekstraSatirlar, token]);

  useEffect(() => {
    fetchHesaplamaData();
    if (isFiyatYonetimiYetkisi) {
      fetchFiyatListesi();
      fetchPaketlerForFiyat();
      fetchModullerForFiyat();
    }
    if (isKomisyonYetkisi) fetchKomisyonOranlari();
  }, [isFiyatYonetimiYetkisi, isKomisyonYetkisi, fetchKomisyonOranlari]);

  useEffect(() => {
    fetchBayiKazanc();
  }, [hesaplamaSonucu, ekstraSatirlar, fetchBayiKazanc]);

  useEffect(() => {
    if (selectedPaket) {
      fetchPaketModulleri();
    } else {
      setAvailableModules([]);
      setSelectedModules([]);
    }
  }, [selectedPaket]);

  // Bayi: paket/modül seçiminde fiyat alanlarını sabit (önerilen) ile doldur
  useEffect(() => {
    if (!fiyatlar || isFiyatYonetimiYetkisi) return;
    if (selectedPaket) {
      setOverridePaketFiyat(String(fiyatlar.Paket?.[parseInt(selectedPaket, 10)] ?? ""));
    } else {
      setOverridePaketFiyat("");
    }
    const norm = (s) => (s || "").toString().toLocaleLowerCase("tr");
    const isEFatura = (mod) => {
      const ad = norm(mod.ProgramAdi || mod.ModulAdi);
      return ad.includes("e-fatura") || (ad.includes("fatura") && ad.startsWith("e"));
    };
    const isEIrsaliye = (mod) => norm(mod.ProgramAdi || mod.ModulAdi).includes("irsaliye");
    const modulO = {};
    selectedModules.forEach((m) => {
      if (isEFatura(m) || isEIrsaliye(m)) return;
      const sabit = fiyatlar.Modul?.[m.Id];
      if (sabit != null) modulO[m.Id] = String(sabit);
    });
    setOverrideModulFiyat(modulO);
  }, [selectedPaket, selectedModules, fiyatlar, moduller, isFiyatYonetimiYetkisi]);

  // Müşteri arama (debounce) – dialog için (Cari Kaynağı = Müşteri)
  useEffect(() => {
    let t = null;
    const q = (musteriQuery || "").trim();
    if (teklifCariKaynagi !== "musteri") return;
    t = setTimeout(async () => {
      try {
        setMusteriLoading(true);
        const res = await axios.get(`${config.baseURL}/musteriler/search`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { query: q, limit: 25, status: "tumu" },
          timeout: 15000,
        });
        const raw = res?.data;
        const list = Array.isArray(raw?.data) ? raw.data : (raw?.musteriler || raw?.rows || []);
        setMusteriOptions(Array.isArray(list) ? list : []);
      } catch (e) {
        console.error("Müşteri arama hatası:", e?.response?.status, e?.response?.data ?? e.message);
        setMusteriOptions([]);
        if (e?.response?.status === 401) toast.error("Oturum süresi dolmuş olabilir, tekrar giriş yapın.");
        else if (e?.response?.status) toast.error("Müşteri listesi alınamadı.");
      } finally {
        setMusteriLoading(false);
      }
    }, q.length === 0 ? 0 : 350);
    return () => {
      if (t) clearTimeout(t);
    };
  }, [musteriQuery, teklifCariKaynagi, token]);

  // Yıllık yenileme: ana ekranda müşteri arama (debounce)
  useEffect(() => {
    if (teklifTipi !== "yillikYenileme") return;
    let t = null;
    const q = (yenilemeMusteriQuery || "").trim();
    t = setTimeout(async () => {
      try {
        setYenilemeMusteriLoading(true);
        const res = await axios.get(`${config.baseURL}/musteriler/search`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { query: q, limit: 25, status: "tumu" },
          timeout: 15000,
        });
        const raw = res?.data;
        const list = Array.isArray(raw?.data) ? raw.data : (raw?.musteriler || raw?.rows || []);
        setYenilemeMusteriOptions(Array.isArray(list) ? list : []);
      } catch (e) {
        console.error("Müşteri arama hatası:", e?.response?.status, e?.response?.data ?? e.message);
        setYenilemeMusteriOptions([]);
        if (e?.response?.status === 401) toast.error("Oturum süresi dolmuş olabilir, tekrar giriş yapın.");
        else if (e?.response?.status) toast.error("Müşteri listesi alınamadı.");
      } finally {
        setYenilemeMusteriLoading(false);
      }
    }, q.length === 0 ? 0 : 350);
    return () => {
      if (t) clearTimeout(t);
    };
  }, [yenilemeMusteriQuery, teklifTipi, token]);

  // Yıllık yenileme: müşteri seçilince lisans bilgisini alıp hesapla
  useEffect(() => {
    if (teklifTipi !== "yillikYenileme" || !yenilemeSelectedMusteri?.Id) return;
    const musteriId = yenilemeSelectedMusteri.Id;
    let cancelled = false;
    (async () => {
      try {
        setYenilemeHesaplaLoading(true);
        const bilgiRes = await axios.get(
          `${config.baseURL}/fiyatlar/musteri-yenileme-bilgi/${musteriId}`,
          { headers: { Authorization: `Bearer ${token}` }, timeout: 15000 }
        );
        if (cancelled || !bilgiRes?.data?.success || !bilgiRes.data.data) return;
        const { PaketId, Paket, ModulIds, KullaniciSayisi, BulutSunucu, OnlineBankaPaket, Lisanslar, LisansId } = bilgiRes.data.data;
        const lisansList = Lisanslar || [];
        setYenilemeLisanslar(lisansList);
        const defaultLisansId = LisansId ?? lisansList?.[0]?.Id ?? null;
        setYenilemeSelectedLisansId(defaultLisansId);
        const paketObj = Paket && typeof Paket === "object" ? Paket : (paketler.find((p) => p.Id === PaketId) || null);
        const modulList = (ModulIds || []).map((id) => {
          const m = moduller.find((mo) => mo.Id === id);
          return m ? { Id: m.Id, ProgramAdi: m.ProgramAdi } : { Id: id, ProgramAdi: `Modül ${id}` };
        });
        setSelectedPaket(String(PaketId));
        setSelectedPaketData(paketObj);
        setAvailableModules(modulList);
        setSelectedModules(modulList);
        setBulutSunucu(BulutSunucu ?? false);
        setOnlineBankaPaket(OnlineBankaPaket ? String(OnlineBankaPaket) : "");
        const selectedLisans = lisansList.find((l) => l.Id === defaultLisansId);
        const kullaniciSayisiForLisans = selectedLisans?.UserCount ?? KullaniciSayisi ?? 1;
        setKullaniciSayisi(kullaniciSayisiForLisans);
        setHesaplamaSonucu(null);
      } catch (e) {
        if (cancelled) return;
        console.error("Yenileme bilgisi/hesapla hatası:", e?.response?.data ?? e.message);
        const msg = e?.response?.data?.message || e?.message || "Yenileme bilgisi alınamadı.";
        toast.error(msg);
        setHesaplamaSonucu(null);
      } finally {
        if (!cancelled) setYenilemeHesaplaLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [teklifTipi, yenilemeSelectedMusteri?.Id, token, paketler, moduller]);

  // Yıllık yenileme: lisans seçimi değişince seçilen lisansa göre hesaplamayı yenile
  useEffect(() => {
    if (teklifTipi !== "yillikYenileme" || !yenilemeSelectedLisansId || !yenilemeLisanslar?.length || !selectedPaket) return;
    const selectedLisans = yenilemeLisanslar.find((l) => l.Id === yenilemeSelectedLisansId);
    if (!selectedLisans) return;
    let cancelled = false;
    (async () => {
      try {
        setYenilemeHesaplaLoading(true);
        const modulIds = selectedModules.map((m) => m.Id).filter(Boolean);
        const kSayisi = selectedLisans.UserCount ?? 1;
        const bayiOverride = !isFiyatYonetimiYetkisi ? (() => {
          const o = {};
          const paketVal = parseFloat(overridePaketFiyat);
          if (!isNaN(paketVal) && paketVal > 0) o.Paket = { [selectedPaket]: paketVal };
          const modulO = {};
          selectedModules.forEach((m) => {
            const v = parseFloat(overrideModulFiyat[m.Id]);
            if (!isNaN(v) && v > 0) modulO[m.Id] = v;
          });
          if (Object.keys(modulO).length > 0) o.Modul = modulO;
          const ekK = Math.max(0, kSayisi - 1);
          const ekToplamVal = overrideEkKullaniciToplam !== "" ? parseFloat(overrideEkKullaniciToplam) : null;
          const ekToplam = ekToplamVal != null && !isNaN(ekToplamVal) ? ekToplamVal : (ekK * (fiyatlar?.EkKullaniciOrani || 0));
          if (ekK > 0 && ekToplam >= 0) o.EkKullaniciOrani = parseFloat((ekToplam / ekK).toFixed(2));
          const efVal = parseFloat(overrideEFaturaEIrsaliyeBirlikte);
          if (!isNaN(efVal) && efVal >= 0) o.EFaturaEIrsaliyeBirlikte = efVal;
          return Object.keys(o).length > 0 ? o : undefined;
        })() : undefined;
        const hesaplaRes = await axios.post(
          `${config.baseURL}/fiyatlar/hesapla`,
          {
            PaketId: Number(selectedPaket),
            ModulIds: modulIds,
            KullaniciSayisi: selectedLisans.UserCount ?? 1,
            BulutSunucu: bulutSunucu ?? false,
            OnlineBankaPaket: onlineBankaPaket ? parseInt(onlineBankaPaket, 10) : null,
            IskontoPaket: Number(paketIskontoOrani) || 0,
            IskontoModul: Number(modulIskontoOrani) || 0,
            IskontoEkKullanici: Number(ekKullaniciIskontoOrani) || 0,
            ...(bayiOverride && { bayiFiyatOverride: bayiOverride }),
          },
          { headers: { Authorization: `Bearer ${token}` }, timeout: 15000 }
        );
        if (cancelled || !hesaplaRes?.data?.success || !hesaplaRes.data.data) return;
        setKullaniciSayisi(selectedLisans.UserCount ?? 1);
        setHesaplamaSonucu(hesaplaRes.data.data);
        toast.success("Yıllık yenileme bedeli hesaplandı.");
      } catch (e) {
        if (cancelled) return;
        console.error("Yenileme hesapla (lisans değişimi) hatası:", e?.response?.data ?? e.message);
        toast.error(e?.response?.data?.message || e?.message || "Hesaplama güncellenemedi.");
      } finally {
        if (!cancelled) setYenilemeHesaplaLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [teklifTipi, yenilemeSelectedLisansId, yenilemeLisanslar, selectedPaket, selectedModules, bulutSunucu, onlineBankaPaket, paketIskontoOrani, modulIskontoOrani, ekKullaniciIskontoOrani, isFiyatYonetimiYetkisi, overridePaketFiyat, overrideModulFiyat, overrideEkKullaniciToplam, overrideEFaturaEIrsaliyeBirlikte, fiyatlar]);

  // Dialog yıllık yenileme için açıldığında cari formu seçili müşteri ile doldur
  useEffect(() => {
    if (!cariDialogOpen || teklifTipi !== "yillikYenileme" || !yenilemeSelectedMusteri) return;
    const v = yenilemeSelectedMusteri;
    const yetkili = (v.Yetkili || "").trim();
    const parts = yetkili ? yetkili.split(" ") : [];
    setCariForm({
      unvan: v.Unvan || "",
      vergiDairesi: v.VergiDairesi || "",
      vergiNo: v.VergiNo || "",
      tcKimlikNo: v.TCKimlikNo || "",
      adi: parts[0] || "",
      soyadi: parts.slice(1).join(" ") || "",
      email: v.EPosta || "",
      telefon: v.Tel || "",
      adresFatura: v.Adres || "",
    });
  }, [cariDialogOpen, teklifTipi, yenilemeSelectedMusteri]);

  // Yeni Lisans: dialog açıldığında potansiyel müşteri ise formu boş bırak; müşteri seçili değilse de boş bırak (seçince dolar)
  useEffect(() => {
    if (!cariDialogOpen || teklifTipi !== "yeniTeklif") return;
    if (teklifCariKaynagi === "potansiyel") {
      setCariForm({ ...bosCariForm });
      return;
    }
    if (teklifCariKaynagi === "musteri" && !selectedMusteri) {
      setCariForm({ ...bosCariForm });
    }
  }, [cariDialogOpen, teklifTipi, teklifCariKaynagi, selectedMusteri]);

  const fetchHesaplamaData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.baseURL}/fiyatlar/hesaplama`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        const aktifPaketler = response.data.data.paketler || [];
        setPaketler(aktifPaketler);
        setModuller(response.data.data.moduller || []);
        setFiyatlar(response.data.data.fiyatlar || {});
      }
      try {
        const detayRes = await axios.get(`${config.baseURL}/paketler/paket-detay-list`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (Array.isArray(detayRes.data) && response.data?.success) {
          const aktifIds = new Set(
            (response.data.data.paketler || []).map((p) => p.Id)
          );
          setPaketDetayList(
            detayRes.data.filter((p) => aktifIds.has(p.PaketId))
          );
        }
      } catch (detayErr) {
        console.error("Paket detay listesi:", detayErr);
      }
    } catch (error) {
      console.error("Hesaplama verileri getirme hatası:", error);
      toast.error("Veriler yüklenirken hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  const fetchPaketModulleri = async (paketIdOverride, paketObjOverride) => {
    const effectivePaketId = paketIdOverride || selectedPaket;
    if (!effectivePaketId) return;
    try {
      const response = await axios.get(
        `${config.baseURL}/paketler/paket-detay/${effectivePaketId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data) {
        // Paket bilgilerini kaydet
        const paket =
          paketObjOverride ||
          paketler.find((p) => p.Id === parseInt(effectivePaketId, 10));
        if (paket) {
          setSelectedPaketData(paket);
          // Kullanıcı sayısını paket maksimumuna göre ayarla
          if (paket.MaxKullaniciSayisi && kullaniciSayisi > paket.MaxKullaniciSayisi) {
            setKullaniciSayisi(paket.MaxKullaniciSayisi);
          }
        }
        
        // Sadece satın alınabilir ek modülleri göster (PaketEkModul tablosundan gelenler)
        // Online Banka modüllerini filtrele (zaten altta ayrı seçim olarak soruluyor)
        const ekModuller = response.data.EkModulDetaylar || [];
        const satinAlinabilirModuller = ekModuller
          .map((m) => ({
            Id: m.ModuleId,
            ProgramAdi: m.ModulAdi,
          }))
          .filter((m) => {
            // Online Banka modüllerini filtrele
            const modulAdi = m.ProgramAdi?.toLowerCase() || "";
            return !modulAdi.includes("online banka") && !modulAdi.includes("onlinebanka");
          });
        setAvailableModules(satinAlinabilirModuller);
        setSelectedModules([]);
      }
    } catch (error) {
      console.error("Paket modülleri getirme hatası:", error);
      toast.error("Paket modülleri yüklenirken hata oluştu");
    }
  };

  const handleHesapla = async () => {
    if (!selectedPaket) {
      toast.error("Paket seçiniz");
      return;
    }

    if (kullaniciSayisi < 1) {
      toast.error("Kullanıcı sayısı en az 1 olmalıdır");
      return;
    }

    // Paket maksimum kullanıcı sayısı kontrolü
    if (selectedPaketData?.MaxKullaniciSayisi && kullaniciSayisi > selectedPaketData.MaxKullaniciSayisi) {
      toast.error(
        `Bu paket maksimum ${selectedPaketData.MaxKullaniciSayisi} kullanıcı destekler`
      );
      return;
    }

    try {
      setCalculating(true);
      const bayiOverride = !isFiyatYonetimiYetkisi ? (() => {
        const o = {};
        const paketVal = parseFloat(overridePaketFiyat);
        if (!isNaN(paketVal) && paketVal > 0) o.Paket = { [selectedPaket]: paketVal };
        const modulO = {};
        selectedModules.forEach((m) => {
          const v = parseFloat(overrideModulFiyat[m.Id]);
          if (!isNaN(v) && v > 0) modulO[m.Id] = v;
        });
        if (Object.keys(modulO).length > 0) o.Modul = modulO;
        const ekK = Math.max(0, kullaniciSayisi - 1);
        const ekToplamVal = overrideEkKullaniciToplam !== "" ? parseFloat(overrideEkKullaniciToplam) : null;
        const ekToplam = ekToplamVal != null && !isNaN(ekToplamVal) ? ekToplamVal : (ekK * (fiyatlar?.EkKullaniciOrani || 0));
        if (ekK > 0 && ekToplam >= 0) o.EkKullaniciOrani = parseFloat((ekToplam / ekK).toFixed(2));
        const efVal = parseFloat(overrideEFaturaEIrsaliyeBirlikte);
        if (!isNaN(efVal) && efVal >= 0) o.EFaturaEIrsaliyeBirlikte = efVal;
        return Object.keys(o).length > 0 ? o : undefined;
      })() : undefined;

      const response = await axios.post(
        `${config.baseURL}/fiyatlar/hesapla`,
        {
          PaketId: parseInt(selectedPaket),
          ModulIds: selectedModules.map((m) => m.Id),
          KullaniciSayisi: parseInt(kullaniciSayisi),
          BulutSunucu: bulutSunucu,
          OnlineBankaPaket: onlineBankaPaket ? parseInt(onlineBankaPaket) : null,
          IskontoPaket: Number(paketIskontoOrani) || 0,
          IskontoModul: Number(modulIskontoOrani) || 0,
          IskontoEkKullanici: Number(ekKullaniciIskontoOrani) || 0,
          ...(bayiOverride && { bayiFiyatOverride: bayiOverride }),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setHesaplamaSonucu(response.data.data);
      }
    } catch (error) {
      console.error("Fiyat hesaplama hatası:", error);
      toast.error(
        error.response?.data?.message || "Fiyat hesaplanırken hata oluştu"
      );
    } finally {
      setCalculating(false);
    }
  };

  const handleModuleToggle = (modul) => {
    const isSelected = selectedModules.some((m) => m.Id === modul.Id);
    if (isSelected) {
      setSelectedModules(selectedModules.filter((m) => m.Id !== modul.Id));
    } else {
      setSelectedModules([...selectedModules, modul]);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 2,
    }).format(value);
  };

  /** Teklif indir: önce cari bilgileri dialogunu açar */
  const handleTeklifPdfIndir = () => {
    if (teklifTipi === "yillikYenileme") {
      if (!hesaplamaSonucu || !yenilemeSelectedMusteri) {
        toast.warning("Önce müşteri seçiniz; yenileme bedeli hesaplandıktan sonra teklif indirebilirsiniz.");
        return;
      }
    } else {
      if (!hesaplamaSonucu || !selectedPaket) {
        toast.warning("Önce fiyat hesaplaması yapınız");
        return;
      }
    }
    setCariDialogOpen(true);
  };

  /** XML + XSL ile tarayıcıda HTML üretir (sunucuda Puppeteer kullanmıyoruz) */
  const teklifDataToHtml = (xml, xsl, logoDataUri) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xml, "text/xml");
    const xslDoc = parser.parseFromString(xsl, "text/xml");
    if (xmlDoc.querySelector("parsererror") || xslDoc.querySelector("parsererror")) {
      throw new Error("XML veya XSL parse hatası");
    }
    const processor = new XSLTProcessor();
    processor.importStylesheet(xslDoc);
    const resultDoc = processor.transformToDocument(xmlDoc);
    const serializer = new XMLSerializer();
    let html =
      resultDoc && resultDoc.documentElement
        ? serializer.serializeToString(resultDoc)
        : "";
    if (!html && processor.transformToFragment) {
      const frag = processor.transformToFragment(xmlDoc, document);
      if (frag && frag.childNodes && frag.childNodes.length > 0) {
        html = serializer.serializeToString(frag);
        if (!/^\s*<!DOCTYPE/i.test(html) && !/^\s*<html/i.test(html)) {
          html = "<!DOCTYPE html><html><head><meta charset=\"UTF-8\"></head><body>" + html + "</body></html>";
        }
      }
    }
    html = (html || "").replace(/src="[^"]*logo32\.png[^"]*"/gi, 'src="' + logoDataUri + '"');
    html = html.replace(/src='[^']*logo32\.png[^']*'/gi, "src='" + logoDataUri + "'");
    // Bayi logosu (örn. /3_logo.png) mutlak URL yap ki public klasöründen yüklensin
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    if (origin) {
      html = html.replace(/src="(\/\d+_logo\.png)"/gi, 'src="' + origin + '$1"');
      html = html.replace(/src='(\/\d+_logo\.png)'/gi, "src='" + origin + "$1'");
    }
    if (!/^\s*<!DOCTYPE\s+html/i.test(html)) html = "<!DOCTYPE html>\n" + html;
    return html;
  };

  /** HTML string'i (full doc) print için body + css'e ayırır */
  const splitHtmlForPrint = (fullHtml) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(String(fullHtml || ""), "text/html");
    const body = doc?.body ? doc.body.innerHTML : String(fullHtml || "");
    const css = Array.from(doc.querySelectorAll("style"))
      .map((s) => s.textContent || "")
      .filter(Boolean)
      .join("\n");
    return { bodyHtml: body, cssText: css };
  };

  /** Print akışı: printBodyHtml set edilince resimler yüklenene kadar bekleyip yazdırma açar */
  useEffect(() => {
    if (!printBodyHtml) return;
    const onAfterPrint = () => {
      setPrintBodyHtml(null);
      setPrintCssText("");
    };
    window.addEventListener("afterprint", onAfterPrint);

    const triggerPrint = () => {
      window.focus();
      window.print();
    };

    const t = setTimeout(() => {
      const root = document.getElementById("__print_root__");
      if (!root) {
        triggerPrint();
        return;
      }
      const imgs = root.querySelectorAll("img");
      if (imgs.length === 0) {
        triggerPrint();
        return;
      }
      let printed = false;
      const doPrint = () => {
        if (printed) return;
        printed = true;
        triggerPrint();
      };
      let loaded = 0;
      const total = imgs.length;
      const checkAll = () => {
        loaded += 1;
        if (loaded >= total) doPrint();
      };
      imgs.forEach((img) => {
        if (img.complete) checkAll();
        else {
          img.addEventListener("load", checkAll);
          img.addEventListener("error", checkAll);
        }
      });
      setTimeout(doPrint, 2500);
    }, 200);

    return () => {
      clearTimeout(t);
      window.removeEventListener("afterprint", onAfterPrint);
    };
  }, [printBodyHtml]);

  /** Cari formu gönderilince teklif verisini alıp mevcut sayfada yazdırma açar (sekme açmaz) */
  const handleTeklifPdfSubmit = async () => {
    try {
      // Yeni müşteri (potansiyel): Vergi No veya TC Kimlik No'dan en az biri zorunlu; Vergi 10, TC 11 hane
      const effectiveMusteriId = teklifTipi === "yillikYenileme" ? yenilemeSelectedMusteri?.Id : selectedMusteri?.Id;
      if (!effectiveMusteriId && teklifTipi === "yeniTeklif" && teklifCariKaynagi === "potansiyel") {
        const vergiNo = (cariForm.vergiNo || "").trim().replace(/\D/g, "");
        const tcNo = (cariForm.tcKimlikNo || "").trim().replace(/\D/g, "");
        if (!vergiNo && !tcNo) {
          toast.error("Vergi No veya TC Kimlik No'dan en az biri zorunludur.");
          return;
        }
        if (vergiNo && vergiNo.length !== 10) {
          toast.error("Vergi numarası 10 haneli olmalıdır.");
          return;
        }
        if (tcNo && tcNo.length !== 11) {
          toast.error("TC Kimlik numarası 11 haneli olmalıdır.");
          return;
        }
      }
      setPdfIndirLoading(true);
      const payload = {
        hesaplamaSonucu,
        paketAdi: selectedPaketData?.Adi ?? "Paket",
        secilenModulAdlari: selectedModules.map((m) => m.ProgramAdi || m.ModulAdi).filter(Boolean),
        kullaniciSayisi,
        teklifTipi,
        iskontoPaket: Number(paketIskontoOrani) || 0,
        iskontoModul: Number(modulIskontoOrani) || 0,
        iskontoEkKullanici: Number(ekKullaniciIskontoOrani) || 0,
        musteriId: effectiveMusteriId || undefined,
        ekstraSatirlar: ekstraSatirlar
          .filter((s) => s.aciklama && (Number(s.birimFiyat) || 0) >= 0)
          .map((s) => ({
            aciklama: s.aciklama,
            miktar: Number(s.miktar) || 1,
            birimFiyat: Number(s.birimFiyat) || 0,
            iskontoOrani: Number(s.iskontoOrani) || 0,
          })),
        cari: {
          unvan: cariForm.unvan || undefined,
          vergiDairesi: cariForm.vergiDairesi || undefined,
          vergiNo: cariForm.vergiNo || undefined,
          tcKimlikNo: cariForm.tcKimlikNo || undefined,
          adi: cariForm.adi || undefined,
          soyadi: cariForm.soyadi || undefined,
          email: cariForm.email || undefined,
          telefon: cariForm.telefon || undefined,
          adresFatura: cariForm.adresFatura || undefined,
        },
      };
      const response = await axios.post(
        `${config.baseURL}/fiyatlar/teklif-html`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "json",
          timeout: 30000,
        }
      );
      if (response.status < 200 || response.status >= 300) {
        let errMsg = "Teklif yüklenemedi";
        try {
          const j = response.data;
          errMsg = j.message || j.error || errMsg;
        } catch (_) {}
        throw new Error(errMsg);
      }
      const { xml, xsl, logoDataUri, teklifNo } = response.data || {};
      if (!xml || !xsl) throw new Error("Sunucu xml/xsl döndürmedi.");
      const html = teklifDataToHtml(xml, xsl, logoDataUri || "");
      if (!html || html.length < 100) throw new Error("Teklif içeriği oluşturulamadı.");
      setCariDialogOpen(false);
      const parts = splitHtmlForPrint(html);
      setPrintCssText(parts.cssText || "");
      setPrintBodyHtml(parts.bodyHtml || "");
      toast.success("Yazdırma penceresi açılıyor. Hedef olarak \"PDF olarak kaydet\" seçebilirsiniz.");

      if (teklifNo) {
        try {
          const korumaRes = await axios.post(
            `${config.baseURL}/fiyatlar/teklif-koruma-kaydet`,
            {
              teklifTipi,
              musteriId: effectiveMusteriId || undefined,
              lisansId: teklifTipi === "yillikYenileme" ? (yenilemeSelectedLisansId ?? undefined) : undefined,
              ekstraSatirlar: ekstraSatirlar
                .filter((s) => s.aciklama && (Number(s.birimFiyat) || 0) >= 0)
                .map((s) => ({
                  aciklama: s.aciklama,
                  miktar: Number(s.miktar) || 1,
                  birimFiyat: Number(s.birimFiyat) || 0,
                  iskontoOrani: Number(s.iskontoOrani) || 0,
                })),
              cari: {
                unvan: cariForm.unvan || undefined,
                vergiDairesi: cariForm.vergiDairesi || undefined,
                vergiNo: cariForm.vergiNo || undefined,
                tcKimlikNo: cariForm.tcKimlikNo || undefined,
                adi: cariForm.adi || undefined,
                soyadi: cariForm.soyadi || undefined,
                email: cariForm.email || undefined,
                telefon: cariForm.telefon || undefined,
                adresFatura: cariForm.adresFatura || undefined,
              },
              hesaplamaSonucu: {
                ...hesaplamaSonucu,
                KullaniciSayisi: kullaniciSayisi,
                OnlineBankaPaket: onlineBankaPaket ? parseInt(onlineBankaPaket, 10) : null,
                paket: {
                  Id: selectedPaketData?.Id ?? null,
                  PaketId: selectedPaketData?.Id ?? null,
                  packageId: selectedPaketData?.Id ?? null,
                  Adi: selectedPaketData?.Adi ?? null,
                },
                secilenModuller: (selectedModules || []).map((m) => ({
                  Id: m.Id,
                  ProgramId: m.Id,
                  ModuleId: m.Id,
                  ProgramAdi: m.ProgramAdi ?? m.ModulAdi ?? "",
                })),
              },
              kullaniciSayisi: kullaniciSayisi,
              onlineBankaPaket: onlineBankaPaket ? parseInt(onlineBankaPaket, 10) : null,
              teklifNo,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
              timeout: 15000,
            }
          );
          if (korumaRes.data && korumaRes.data.success) {
            if (korumaRes.data.lisansYenilemeTalep || teklifTipi === "yillikYenileme") {
              toast.success(korumaRes.data.message || "Lisans yenileme talebi oluşturuldu.");
            } else {
              toast.success("Teklif korumaya alındı.");
              navigate("/teklifler", { replace: false });
            }
          }
        } catch (korumaErr) {
          console.error("Teklif koruma kaydetme hatası:", korumaErr);
          const msg = korumaErr.response?.data?.message || korumaErr.message || "Bilinmeyen hata";
          toast.warning("Teklif açıldı; koruma kaydı oluşmadı: " + msg);
        }
      } else {
        toast.info("Teklif açıldı. Teklif numarası alınamadığı için otomatik koruma kaydı oluşturulmadı.");
      }
    } catch (error) {
      console.error("Teklif yazdırma hatası:", error);
      let msg = "Teklif açılamadı";
      if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
        msg = "Sunucuya bağlanılamadı. Backend (port 5000) çalışıyor mu? Teklif oluşturma 1–2 dakika sürebilir, tekrar deneyin.";
      } else if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
        msg = "İstek zaman aşımına uğradı. Sunucu yoğun olabilir, tekrar deneyin.";
      } else if (error.response?.data) {
        if (typeof error.response.data === "string") {
          try {
            const parsed = JSON.parse(error.response.data);
            msg = parsed.message || parsed.error || msg;
          } catch (_) {
            msg = error.response.data.substring(0, 200);
          }
        } else if (error.response.data?.message) msg = error.response.data.message;
      } else if (error.message) msg = error.message;
      toast.error(msg);
    } finally {
      setPdfIndirLoading(false);
    }
  };

  /* Boş teklif PDF – lazım olunca yorumdan çıkar
  const handleBosTeklifPdfIndir = async () => {
    try {
      setBosPdfIndirLoading(true);
      const response = await axios.get(
        `${config.baseURL}/fiyatlar/bos-teklif-html`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "json",
          timeout: 15000,
        }
      );
      if (response.status < 200 || response.status >= 300) {
        let errMsg = "Boş teklif yüklenemedi";
        try {
          const j = response.data;
          errMsg = j.message || j.error || errMsg;
        } catch (_) {}
        throw new Error(errMsg);
      }
      const { xml, xsl, logoDataUri } = response.data || {};
      if (!xml || !xsl) throw new Error("Sunucu xml/xsl döndürmedi.");
      const html = teklifDataToHtml(xml, xsl, logoDataUri || "");
      if (!html || html.length < 100) throw new Error("Boş teklif içeriği oluşturulamadı.");
      const parts = splitHtmlForPrint(html);
      setPrintCssText(parts.cssText || "");
      setPrintBodyHtml(parts.bodyHtml || "");
      toast.success("Yazdırma penceresi açılıyor. Hedef olarak \"PDF olarak kaydet\" seçebilirsiniz.");
    } catch (error) {
      console.error("Boş teklif yazdırma hatası:", error);
      let msg = "Boş teklif açılamadı";
      if (error.response?.data) {
        if (typeof error.response.data === "string") {
          try {
            const parsed = JSON.parse(error.response.data);
            msg = parsed.message || parsed.error || msg;
          } catch (_) {
            msg = error.response.data.substring(0, 200);
          }
        } else if (error.response.data?.message) msg = error.response.data.message;
      } else if (error.message) msg = error.message;
      toast.error(msg);
    } finally {
      setBosPdfIndirLoading(false);
    }
  };
  */

  /* Teklif XML indir – lazım olunca yorumdan çıkar
  const handleTeklifXmlIndir = async () => {
    if (!hesaplamaSonucu || !selectedPaket) {
      toast.warning("Önce fiyat hesaplaması yapınız");
      return;
    }
    try {
      setXmlIndirLoading(true);
      const payload = {
        hesaplamaSonucu,
        paketAdi: selectedPaketData?.Adi ?? "Paket",
        secilenModulAdlari: selectedModules.map((m) => m.ProgramAdi || m.Adi).filter(Boolean),
        kullaniciSayisi,
      };
      const response = await axios.post(
        `${config.baseURL}/fiyatlar/teklif-xml`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "text",
        }
      );
      if (response.status < 200 || response.status >= 300) {
        let errMsg = "XML indirilemedi";
        try {
          const raw = typeof response.data === "string" ? response.data : String(response.data);
          const j = JSON.parse(raw);
          errMsg = j.message || j.error || errMsg;
        } catch (_) {}
        throw new Error(errMsg);
      }
      const xmlString = typeof response.data === "string" ? response.data : String(response.data);
      const blob = new Blob([xmlString], { type: "application/xml; charset=utf-8" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Teklif-XML-${selectedPaketData?.Adi || "Fiyat"}-${Date.now()}.xml`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success("Teklif XML indirildi");
    } catch (error) {
      console.error("Teklif XML indirme hatası:", error);
      const msg = error.response?.data?.message ?? error.message ?? "XML indirilemedi";
      toast.error(typeof msg === "string" ? msg : "XML indirilemedi");
    } finally {
      setXmlIndirLoading(false);
    }
  };
  */

  // Yıllık yenileme bedeli hesaplama
  const calculateYillikYenileme = () => {
    if (!hesaplamaSonucu || !selectedPaketData) return null;

    const paketAdi = selectedPaketData.Adi?.toLowerCase() || "";
    const toplamFiyat = hesaplamaSonucu.toplamFiyat || 0;
    const paketFiyati = hesaplamaSonucu.hesaplamaDetaylari?.paketFiyati || 0;
    const modulFiyatlari = hesaplamaSonucu.hesaplamaDetaylari?.modulFiyatlari || 0;
    const ekKullaniciFiyati = hesaplamaSonucu.hesaplamaDetaylari?.ekKullaniciFiyati || 0;
    const eFaturaEIrsaliyeFiyati = hesaplamaSonucu.hesaplamaDetaylari?.eFaturaEIrsaliyeFiyati || 0;
    const onlineBankaFiyati = hesaplamaSonucu.hesaplamaDetaylari?.onlineBankaFiyati || 0;
    const bulutSunucuFiyati = hesaplamaSonucu.hesaplamaDetaylari?.bulutSunucuFiyati || 0;
    const bulutSunucuEkKullaniciFiyati = hesaplamaSonucu.hesaplamaDetaylari?.bulutSunucuEkKullaniciFiyati || 0;
    const toplamBulutSunucuFiyati = bulutSunucuFiyati + bulutSunucuEkKullaniciFiyati;

    // Paket + Modül + Ek Kullanıcı + E-Fatura/E-İrsaliye Birlikte toplamı (Online Banka ve Bulut Sunucu hariç)
    // Eğer E-Fatura ve E-İrsaliye birlikte seçilmişse, eFaturaEIrsaliyeFiyati eklenir
    // Ayrı ayrıysa zaten modulFiyatlari içinde geçiyor
    const paketModulEkKullaniciToplam = paketFiyati + modulFiyatlari + ekKullaniciFiyati + eFaturaEIrsaliyeFiyati;

    let paketYenilemeUcreti = 0;

    if (paketAdi.includes("shift")) {
      // Shift paketi: (Paket + Modül + Ek Kullanıcı) × %100
      paketYenilemeUcreti = paketModulEkKullaniciToplam * 1.0;
    } else if (paketAdi.includes("fast")) {
      // Fast paketi: (Paket + Modül + Ek Kullanıcı) × %50
      paketYenilemeUcreti = paketModulEkKullaniciToplam * 0.5;
    } else if (paketAdi.includes("starter") || paketAdi.includes("master") || paketAdi.includes("pro")) {
      // Starter, Master, Pro: (Paket + Modül + Ek Kullanıcı) × %20
      paketYenilemeUcreti = paketModulEkKullaniciToplam * 0.2;
    }

    const toplamYillikYenileme = paketYenilemeUcreti + onlineBankaFiyati + toplamBulutSunucuFiyati;

    return {
      paketYenilemeUcreti,
      onlineBankaFiyati,
      bulutSunucuFiyati: toplamBulutSunucuFiyati,
      toplamYillikYenileme,
    };
  };

  // Fiyat Yönetimi fonksiyonları
  const fetchFiyatListesi = async () => {
    try {
      setFiyatLoading(true);
      const response = await axios.get(`${config.baseURL}/fiyatlar`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        setFiyatListesi(response.data.data || []);
      } else {
        toast.error(response.data.message || "Fiyatlar yüklenirken hata oluştu");
      }
    } catch (error) {
      console.error("Fiyatlar getirme hatası:", error);
      const errorMessage = error.response?.data?.message || "Fiyatlar yüklenirken hata oluştu";
      toast.error(errorMessage);
      // 403 hatası ise yetki yok demektir
      if (error.response?.status === 403) {
        console.error("Fiyat yönetimi için yetkiniz bulunmamaktadır");
      }
    } finally {
      setFiyatLoading(false);
    }
  };

  const fetchPaketlerForFiyat = async () => {
    try {
      const response = await axios.get(`${config.baseURL}/paketler`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // API direkt array döndürüyor (res.send(paketler))
      if (Array.isArray(response.data)) {
        setPaketler(response.data || []);
      } else if (response.data && response.data.data) {
        setPaketler(response.data.data || []);
      }
    } catch (error) {
      console.error("Paketler getirme hatası:", error);
      toast.error("Paketler yüklenirken hata oluştu");
    }
  };

  const fetchModullerForFiyat = async () => {
    try {
      const response = await axios.get(`${config.baseURL}/program`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // API direkt array döndürüyor (res.send(programlar))
      let modullerList = [];
      if (Array.isArray(response.data)) {
        modullerList = response.data;
      } else if (response.data && response.data.data) {
        modullerList = response.data.data;
      }
      // Sadece IsZet = 1 olan modülleri al
      const filteredModuller = modullerList.filter(
        (m) => m.IsZet === 1 && m.SiraNo !== null && m.SiraNo !== ""
      );
      setModuller(filteredModuller || []);
    } catch (error) {
      console.error("Modüller getirme hatası:", error);
      toast.error("Modüller yüklenirken hata oluştu");
    }
  };

  const handleOpenFiyatDialog = (fiyat = null) => {
    if (fiyat) {
      setEditingFiyat(fiyat);
      setFormData({
        FiyatTipi: fiyat.FiyatTipi,
        ReferansId: fiyat.ReferansId || "",
        Fiyat: fiyat.Fiyat,
        Aciklama: fiyat.Aciklama || "",
        Etkin: fiyat.Etkin,
      });
    } else {
      setEditingFiyat(null);
      setFormData({
        FiyatTipi: "",
        ReferansId: "",
        Fiyat: "",
        Aciklama: "",
        Etkin: true,
      });
    }
    setDialogOpen(true);
  };

  const handleCloseFiyatDialog = () => {
    setDialogOpen(false);
    setEditingFiyat(null);
    setFormData({
      FiyatTipi: "",
      ReferansId: "",
      Fiyat: "",
      Aciklama: "",
      Etkin: true,
    });
  };

  const handleSaveFiyat = async () => {
    try {
      if (!formData.FiyatTipi) {
        toast.error("Fiyat tipi seçiniz");
        return;
      }

      if (formData.Fiyat === "" || formData.Fiyat < 0) {
        toast.error("Geçerli bir fiyat giriniz");
        return;
      }

      const payload = {
        ...formData,
        Id: editingFiyat?.Id || null,
        ReferansId: formData.ReferansId || null,
        Fiyat: parseFloat(formData.Fiyat),
      };

      const url = editingFiyat
        ? `${config.baseURL}/fiyatlar/${editingFiyat.Id}`
        : `${config.baseURL}/fiyatlar`;
      const method = editingFiyat ? "put" : "post";

      const response = await axios[method](url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        toast.success(
          editingFiyat ? "Fiyat güncellendi" : "Fiyat oluşturuldu"
        );
        handleCloseFiyatDialog();
        // Listeyi yenile
        await fetchFiyatListesi();
        fetchHesaplamaData(); // Hesaplama verilerini de yenile
      } else {
        toast.error(response.data.message || "Fiyat kaydedilemedi");
      }
    } catch (error) {
      console.error("Fiyat kaydetme hatası:", error);
      toast.error(
        error.response?.data?.message || "Fiyat kaydedilirken hata oluştu"
      );
    }
  };

  const handleDeleteFiyat = async (id) => {
    if (!window.confirm("Bu fiyatı silmek istediğinizden emin misiniz?")) {
      return;
    }

    try {
      await axios.delete(`${config.baseURL}/fiyatlar/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Fiyat silindi");
      fetchFiyatListesi();
      fetchHesaplamaData(); // Hesaplama verilerini de yenile
    } catch (error) {
      console.error("Fiyat silme hatası:", error);
      toast.error("Fiyat silinirken hata oluştu");
    }
  };

  const getFiyatTipiLabel = (tip) => {
    const labels = {
      Paket: "Paket",
      Modul: "Modül",
      EkKullaniciOrani: "Ek Kullanıcı Oranı (%)",
      BulutSunucu: "Bulut Sunucu",
      BulutSunucuEkKullanici: "Bulut Sunucu Ek Kullanıcı",
      EFaturaEIrsaliyeBirlikte: "E-Fatura + E-İrsaliye (Birlikte)",
      OnlineBanka1: "Online Banka (1 Banka)",
      OnlineBanka5: "Online Banka (5 Banka)",
      OnlineBanka10: "Online Banka (10 Banka)",
      OnlineBanka15: "Online Banka (15 Banka)",
      OnlineBanka20: "Online Banka (20 Banka)",
    };
    return labels[tip] || tip;
  };

  const getReferansAdi = (tip, referansId) => {
    if (tip === "Paket") {
      const paket = paketler.find((p) => p.Id === referansId);
      return paket ? paket.Adi : `ID: ${referansId}`;
    } else if (tip === "Modul") {
      const modul = moduller.find((m) => m.Id === referansId);
      return modul ? modul.ProgramAdi : `ID: ${referansId}`;
    }
    return "-";
  };

  const fiyatTipleri = [
    "Paket",
    "Modul",
    "EkKullaniciOrani",
    "BulutSunucu",
    "BulutSunucuEkKullanici",
    "EFaturaEIrsaliyeBirlikte",
    "OnlineBanka1",
    "OnlineBanka5",
    "OnlineBanka10",
    "OnlineBanka15",
    "OnlineBanka20",
  ];

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  const printContainer = (
    <div id="__print_container__">
      <style>{printCssText}</style>
      <style>{`
        /* Ekranda asla görünmesin */
        @media screen {
          #__print_container__ { display: none !important; }
        }
        /* Yazdırmada sadece teklif görünsün (container body'de, #root dışında) */
        @media print {
          #root { display: none !important; }
          #__print_container__ { display: block !important; visibility: visible !important; }
          #__print_container__ * { visibility: visible !important; }
        }
      `}</style>
      <div id="__print_root__" dangerouslySetInnerHTML={{ __html: printBodyHtml || "" }} />
    </div>
  );

  return (
    <Box className="fh-page">
      {createPortal(printContainer, document.body)}
      <header className="fh-page-header">
        <div className="fh-page-header-text">
          <Typography component="h1" variant="h5" sx={{ fontWeight: 700, letterSpacing: "-0.03em", color: "#0f172a", mb: 0 }}>
            Fiyat Hesaplama Sihirbazı
          </Typography>
        </div>
        <button
          type="button"
          className="fh-btn-reset"
          onClick={() => {
              setSelectedPaket("");
              setSelectedPaketData(null);
              setSelectedModules([]);
              setAvailableModules([]);
              setKullaniciSayisi(1);
              setPaketIskontoOrani(0);
              setModulIskontoOrani(0);
              setEkKullaniciIskontoOrani(0);
              setBulutSunucu(false);
              setOnlineBankaPaket("");
              setHesaplamaSonucu(null);
              setYenilemeSelectedMusteri(null);
              setYenilemeMusteriQuery("");
              setYenilemeMusteriOptions([]);
              setEkstraSatirlar([]);
              setWizardKey((k) => k + 1);
              fetchHesaplamaData();
              if (isFiyatYonetimiYetkisi) {
                fetchFiyatListesi();
              }
          }}
        >
          <RestartAlt sx={{ fontSize: 18 }} />
          Sıfırla
        </button>
      </header>

      <Paper className="fh-tabs-wrap" elevation={0}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{
            minHeight: 48,
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.9rem",
              minHeight: 44,
              color: "#64748b",
            },
          }}
        >
          <Tab label="Fiyat Hesaplama" />
          {isFiyatYonetimiYetkisi && <Tab label="Fiyat Yönetimi" />}
          {isKomisyonYetkisi && <Tab label="Komisyon Yönetimi" />}
        </Tabs>
      </Paper>

      {activeTab === 0 && (
        <Box className="fh-content-scroll">
          <div className="fh-teklif-bar">
            <span className="fh-teklif-bar-label">Teklif tipi</span>
            <div className="fh-teklif-segment" role="radiogroup" aria-label="Teklif tipi">
              <label>
                <input
                  type="radio"
                  name="teklifTipi"
                  value="yeniTeklif"
                  checked={teklifTipi === "yeniTeklif"}
                  onChange={() => {
                    setTeklifTipi("yeniTeklif");
                    setYenilemeSelectedMusteri(null);
                    setYenilemeMusteriQuery("");
                    setHesaplamaSonucu(null);
                  }}
                />
                <span>Yeni Lisans</span>
              </label>
              <label>
                <input
                  type="radio"
                  name="teklifTipi"
                  value="yillikYenileme"
                  checked={teklifTipi === "yillikYenileme"}
                  onChange={() => {
                    setTeklifTipi("yillikYenileme");
                    setSelectedPaket("");
                    setSelectedPaketData(null);
                    setSelectedModules([]);
                    setHesaplamaSonucu(null);
                  }}
                />
                <span>Yıllık Yenileme</span>
              </label>
            </div>
          </div>

          {teklifTipi === "yeniTeklif" ? (
            <FiyatHesaplamaWizard
              key={wizardKey}
              token={token}
              paketler={paketler}
              fiyatlar={fiyatlar}
              paketDetayList={paketDetayList}
              selectedPaket={selectedPaket}
              setSelectedPaket={setSelectedPaket}
              selectedPaketData={selectedPaketData}
              setSelectedPaketData={setSelectedPaketData}
              availableModules={availableModules}
              setAvailableModules={setAvailableModules}
              selectedModules={selectedModules}
              setSelectedModules={setSelectedModules}
              kullaniciSayisi={kullaniciSayisi}
              setKullaniciSayisi={setKullaniciSayisi}
              setPaketIskontoOrani={setPaketIskontoOrani}
              setModulIskontoOrani={setModulIskontoOrani}
              setEkKullaniciIskontoOrani={setEkKullaniciIskontoOrani}
              bulutSunucu={bulutSunucu}
              setBulutSunucu={setBulutSunucu}
              onlineBankaPaket={onlineBankaPaket}
              setOnlineBankaPaket={setOnlineBankaPaket}
              hesaplamaSonucu={hesaplamaSonucu}
              setHesaplamaSonucu={setHesaplamaSonucu}
              bayiKazanc={bayiKazanc}
              onTeklifOlustur={handleTeklifPdfIndir}
              pdfIndirLoading={pdfIndirLoading}
              fetchPaketModulleri={fetchPaketModulleri}
            />
          ) : (
          <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
              <>
                <Typography variant="h6" fontWeight={600} mb={3}>
                  Müşteri Seç
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Yıllık yenileme teklifi için müşteriyi seçin. Müşterinin aktif lisans bilgilerine göre yenileme bedeli hesaplanacaktır.
                </Typography>
                <Autocomplete
                  options={yenilemeMusteriOptions}
                  loading={yenilemeMusteriLoading || yenilemeHesaplaLoading}
                  value={yenilemeSelectedMusteri}
                  inputValue={yenilemeMusteriQuery}
                  onInputChange={(_, v) => setYenilemeMusteriQuery(v)}
                  onChange={(_, v) => {
                    setYenilemeSelectedMusteri(v);
                    setYenilemeLisanslar([]);
                    setYenilemeSelectedLisansId(null);
                  }}
                  getOptionLabel={(o) => {
                    if (!o) return "";
                    const unvan = o.Unvan || o.unvan || "";
                    const vergiNo = o.VergiNo || o.vergiNo || "";
                    const musteriNo = o.MusteriNo || o.musteriNo || "";
                    return `${unvan}${musteriNo ? " (" + musteriNo + ")" : ""}${vergiNo ? " - " + vergiNo : ""}`;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Müşteri Ara (Unvan / Vergi No / Müşteri No)"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {(yenilemeMusteriLoading || yenilemeHesaplaLoading) ? <CircularProgress color="inherit" size={18} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
                {yenilemeLisanslar.length > 1 && (
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Hangi lisans için yenileme?</InputLabel>
                    <Select
                      value={yenilemeSelectedLisansId ?? ""}
                      onChange={(e) => setYenilemeSelectedLisansId(e.target.value ? Number(e.target.value) : null)}
                      label="Hangi lisans için yenileme?"
                    >
                      {yenilemeLisanslar.map((lisans) => {
                        const bitisStr = lisans.BitisTarih ? new Date(lisans.BitisTarih).toLocaleDateString("tr-TR") : "";
                        const label = `Kullanıcı No: ${lisans.UserNo ?? "-"} | Bitiş: ${bitisStr} | ${lisans.LisansTipi ?? "Yıllık"}`;
                        return (
                          <MenuItem key={lisans.Id} value={lisans.Id}>
                            {label}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                )}
                <Button
                  fullWidth
                  variant="outlined"
                  size="large"
                  startIcon={pdfIndirLoading ? <CircularProgress size={20} /> : <PictureAsPdf />}
                  onClick={handleTeklifPdfIndir}
                  disabled={!hesaplamaSonucu || !yenilemeSelectedMusteri || pdfIndirLoading}
                  sx={{
                    borderColor: "#10B981",
                    color: "#10B981",
                    "&:hover": { borderColor: "#059669", bgcolor: "rgba(16,185,129,0.08)" },
                    py: 1.5,
                    mt: 2,
                  }}
                >
                  Teklif PDF İndir
                </Button>
              </>
          </Paper>
        </Grid>

        {/* Sağ Taraf - Sonuç */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" fontWeight={600} mb={3}>
              Hesaplama Sonucu
            </Typography>

            {hesaplamaSonucu ? (
              <Box>
                <Card
                  sx={{
                    bgcolor: "#F0FDF4",
                    border: "2px solid #10B981",
                    mb: 2,
                  }}
                >
                  <CardContent>
                    <Typography variant="h4" fontWeight={700} color="#10B981">
                      {formatCurrency(
                        (hesaplamaSonucu.toplamFiyat ?? 0) +
                          (ekstraSatirlar || []).reduce(
                            (acc, s) =>
                              acc +
                              (Number(s.miktar) || 0) *
                                (Number(s.birimFiyat) || 0) *
                                (1 - Math.max(0, Math.min(100, Number(s.iskontoOrani) || 0)) / 100),
                            0
                          )
                      )}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Toplam Fiyat
                    </Typography>
                  </CardContent>
                </Card>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" fontWeight={600} mb={1}>
                    Hesaplama Detayları
                  </Typography>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    {((hesaplamaSonucu.hesaplamaDetaylari.paketFiyatiOrijinal ?? hesaplamaSonucu.hesaplamaDetaylari.paketFiyati) ?? 0) > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 1,
                          bgcolor: "#F9FAFB",
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant="body2">Paket Fiyatı:</Typography>
                        <Typography variant="body2" fontWeight={600}>
                          {formatCurrency(
                            hesaplamaSonucu.hesaplamaDetaylari.paketFiyatiOrijinal ??
                              hesaplamaSonucu.hesaplamaDetaylari.paketFiyati
                          )}
                        </Typography>
                      </Box>
                    )}
                    {((hesaplamaSonucu.hesaplamaDetaylari.modulFiyatlariOrijinal ?? 0) > 0 ||
                      (hesaplamaSonucu.hesaplamaDetaylari.modulFiyatlari ?? 0) + (hesaplamaSonucu.hesaplamaDetaylari.eFaturaEIrsaliyeFiyati ?? 0) > 0) && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 1,
                          bgcolor: "#F9FAFB",
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant="body2">
                          Modül Fiyatları (E-Fatura / E-İrsaliye dahil):
                        </Typography>
                        <Typography variant="body2" fontWeight={600}>
                          {formatCurrency(
                            hesaplamaSonucu.hesaplamaDetaylari.modulFiyatlariOrijinal ??
                              (hesaplamaSonucu.hesaplamaDetaylari.modulFiyatlari || 0) +
                                (hesaplamaSonucu.hesaplamaDetaylari.eFaturaEIrsaliyeFiyati || 0)
                          )}
                        </Typography>
                      </Box>
                    )}
                    {(hesaplamaSonucu.hesaplamaDetaylari.ekKullaniciFiyati > 0 ||
                      (hesaplamaSonucu.hesaplamaDetaylari.ekKullaniciFiyatiOrijinal ?? 0) > 0) && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 1,
                          bgcolor: "#F9FAFB",
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant="body2">
                          Ek Kullanıcı Fiyatı ({kullaniciSayisi - 1} kullanıcı):
                        </Typography>
                        <Typography variant="body2" fontWeight={600}>
                          {formatCurrency(
                            hesaplamaSonucu.hesaplamaDetaylari.ekKullaniciFiyatiOrijinal ??
                              hesaplamaSonucu.hesaplamaDetaylari.ekKullaniciFiyati
                          )}
                        </Typography>
                      </Box>
                    )}
                    {(hesaplamaSonucu.hesaplamaDetaylari.toplamIskontoTutari ?? 0) > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 1,
                          bgcolor: "#E8F5E9",
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant="body2">Toplam İndirim:</Typography>
                        <Typography variant="body2" fontWeight={600} color="success.dark">
                          -{formatCurrency(hesaplamaSonucu.hesaplamaDetaylari.toplamIskontoTutari)}
                        </Typography>
                      </Box>
                    )}
                    {hesaplamaSonucu.hesaplamaDetaylari.bulutSunucuFiyati > 0 && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            p: 1,
                            bgcolor: "#F9FAFB",
                            borderRadius: 1,
                          }}
                        >
                          <Typography variant="body2">Bulut Sunucu:</Typography>
                          <Typography variant="body2" fontWeight={600}>
                            {formatCurrency(
                              hesaplamaSonucu.hesaplamaDetaylari.bulutSunucuFiyati
                            )}
                          </Typography>
                        </Box>
                        {hesaplamaSonucu.hesaplamaDetaylari
                          .bulutSunucuEkKullaniciFiyati > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              p: 1,
                              bgcolor: "#F9FAFB",
                              borderRadius: 1,
                            }}
                          >
                            <Typography variant="body2">
                              Bulut Sunucu Ek Kullanıcı:
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                              {formatCurrency(
                                hesaplamaSonucu.hesaplamaDetaylari
                                  .bulutSunucuEkKullaniciFiyati
                              )}
                            </Typography>
                          </Box>
                        )}
                      </>
                    )}
                    {hesaplamaSonucu.hesaplamaDetaylari.onlineBankaFiyati > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 1,
                          bgcolor: "#F9FAFB",
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant="body2">Online Banka Paketi:</Typography>
                        <Typography variant="body2" fontWeight={600}>
                          {formatCurrency(
                            hesaplamaSonucu.hesaplamaDetaylari.onlineBankaFiyati
                          )}
                        </Typography>
                      </Box>
                    )}
                    {(() => {
                      const ekToplam = (ekstraSatirlar || []).reduce(
                        (acc, s) =>
                          acc +
                          (Number(s.miktar) || 0) *
                            (Number(s.birimFiyat) || 0) *
                            (1 - Math.max(0, Math.min(100, Number(s.iskontoOrani) || 0)) / 100),
                        0
                      );
                      return ekToplam > 0 ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            p: 1,
                            bgcolor: "#E3F2FD",
                            borderRadius: 1,
                          }}
                        >
                          <Typography variant="body2">Ek Satırlar Toplam:</Typography>
                          <Typography variant="body2" fontWeight={600}>
                            {formatCurrency(parseFloat(ekToplam.toFixed(2)))}
                          </Typography>
                        </Box>
                      ) : null;
                    })()}
                  </Box>
                </Box>

                {/* Yıllık Yenileme Bedeli */}
                {calculateYillikYenileme() && (
                  <>
                    <Divider sx={{ my: 2 }} />
                    <Box>
                      <Typography variant="subtitle2" fontWeight={600} mb={1}>
                        Yıllık Yenileme Bedeli
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {calculateYillikYenileme().paketYenilemeUcreti > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              p: 1,
                              bgcolor: "#FEF3C7",
                              borderRadius: 1,
                            }}
                          >
                            <Typography variant="body2">Paket Yenileme Ücreti:</Typography>
                            <Typography variant="body2" fontWeight={600}>
                              {formatCurrency(calculateYillikYenileme().paketYenilemeUcreti)}
                            </Typography>
                          </Box>
                        )}
                        {calculateYillikYenileme().onlineBankaFiyati > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              p: 1,
                              bgcolor: "#FEF3C7",
                              borderRadius: 1,
                            }}
                          >
                            <Typography variant="body2">Online Banka Ücreti:</Typography>
                            <Typography variant="body2" fontWeight={600}>
                              {formatCurrency(calculateYillikYenileme().onlineBankaFiyati)}
                            </Typography>
                          </Box>
                        )}
                        {calculateYillikYenileme().bulutSunucuFiyati > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              p: 1,
                              bgcolor: "#FEF3C7",
                              borderRadius: 1,
                            }}
                          >
                            <Typography variant="body2">Bulut Sunucu Ücreti:</Typography>
                            <Typography variant="body2" fontWeight={600}>
                              {formatCurrency(calculateYillikYenileme().bulutSunucuFiyati)}
                            </Typography>
                          </Box>
                        )}
                        <Card
                          sx={{
                            bgcolor: "#FEF3C7",
                            border: "2px solid #F59E0B",
                            mt: 1,
                          }}
                        >
                          <CardContent>
                            <Typography variant="h6" fontWeight={700} color="#F59E0B">
                              {formatCurrency(calculateYillikYenileme().toplamYillikYenileme)}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              Toplam Yıllık Yenileme Tutarı
                            </Typography>
                          </CardContent>
                        </Card>
                      </Box>
                    </Box>
                  </>
                )}

                {/* Bayi Kazanç ve Bayinin Ödeyeceği Tutar - Ana merkez (Genel Merkez) girişinde gösterilmez */}
                {bayiKazanc != null && bayiKazanc.tier !== "genelMerkez" && (
                  <>
                    <Divider sx={{ my: 2 }} />
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                      <Typography variant="subtitle2" fontWeight={600} color="text.secondary">
                        Bayi Bilgisi ({bayiKazanc.tier === "altin" ? "Altın" : bayiKazanc.tier === "gumus" ? "Gümüş" : "Bronz"} Bayi)
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 1.5,
                          bgcolor: "#EFF6FF",
                          borderRadius: 1,
                          border: "1px solid #3B82F6",
                        }}
                      >
                        <Typography variant="body2">Bayi Kazanç:</Typography>
                        <Typography variant="body1" fontWeight={700} color="#3B82F6">
                          {formatCurrency(bayiKazanc.bayiKazanc ?? 0)}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 1.5,
                          bgcolor: "#FEF2F2",
                          borderRadius: 1,
                          border: "1px solid #EF4444",
                        }}
                      >
                        <Typography variant="body2">Bayinin Ödeyeceği Tutar:</Typography>
                        <Typography variant="body1" fontWeight={700} color="#EF4444">
                          {formatCurrency(bayiKazanc.bayiOdeme ?? 0)}
                        </Typography>
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            ) : (
              <Box
                sx={{
                  textAlign: "center",
                  py: 4,
                  color: "text.secondary",
                }}
              >
                <Typography variant="body1">
                  Yıllık yenileme için soldan müşteri seçin; lisans bilgilerine göre yenileme bedeli hesaplanacaktır.
                </Typography>
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>
          )}
        </Box>
      )}

      {/* Komisyon Yönetimi Tab - sadece BayiId 1 */}
      {activeTab === 2 && isKomisyonYetkisi && (
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
            Komisyon Oranları (Altın / Gümüş / Bronz Bayi)
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Her kalem için bayi statüsüne göre komisyon oranını (%) girin. Bayi kazanç hesaplamasında iskontolu fiyat üzerinden komisyon uygulanır.
          </Typography>
          {komisyonLoading ? (
            <Box display="flex" justifyContent="center" p={4}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: "#F3F4F6" }}>
                    <TableCell sx={{ fontWeight: 600, minWidth: 140 }}>Kalem</TableCell>
                    <TableCell sx={{ fontWeight: 600 }} align="center">Altın (%)</TableCell>
                    <TableCell sx={{ fontWeight: 600 }} align="center">Gümüş (%)</TableCell>
                    <TableCell sx={{ fontWeight: 600 }} align="center">Bronz (%)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[
                    { key: "paket", label: "Paket" },
                    { key: "modul", label: "Modül" },
                    { key: "ekKullanici", label: "Ek Kullanıcı" },
                    { key: "bulutSunucu", label: "Bulut Sunucu" },
                    { key: "onlineBanka", label: "Online Banka" },
                    { key: "ekSatir", label: "Ek Satır" },
                  ].map(({ key, label }) => (
                    <TableRow key={key} hover>
                      <TableCell sx={{ fontWeight: 500 }}>{label}</TableCell>
                      {["altin", "gumus", "bronz"].map((tier) => (
                        <TableCell key={tier} align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={komisyonGrid[key]?.[tier] ?? ""}
                            onChange={(e) => {
                              const v = Math.max(0, Math.min(100, Number(e.target.value) || 0));
                              setKomisyonGrid((prev) => ({
                                ...prev,
                                [key]: { ...(prev[key] || {}), [tier]: v },
                              }));
                            }}
                            inputProps={{ min: 0, max: 100, step: 0.5 }}
                            sx={{ width: 90 }}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              startIcon={komisyonSaving ? <CircularProgress size={18} color="inherit" /> : <Save />}
              onClick={saveKomisyonOranlari}
              disabled={komisyonLoading || komisyonSaving}
              sx={{ bgcolor: "#00A7B5", "&:hover": { bgcolor: "#008B98" } }}
            >
              Kaydet
            </Button>
          </Box>
        </Box>
      )}

      {/* Fiyat Yönetimi Tab */}
      {activeTab === 1 && isFiyatYonetimiYetkisi && (
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              Fiyat Yönetimi
            </Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => handleOpenFiyatDialog()}
              sx={{
                bgcolor: "#00A7B5",
                "&:hover": { bgcolor: "#008B98" },
              }}
            >
              Fiyat Belirle
            </Button>
          </Box>

          {fiyatLoading ? (
            <Box display="flex" justifyContent="center" p={4}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer 
              component={Paper}
              sx={{
                maxHeight: "calc(100vh - 300px)",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "4px",
                  "&:hover": {
                    background: "#555",
                  },
                },
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ bgcolor: "#F3F4F6" }}>
                    <TableCell fontWeight={600}>Fiyat Tipi</TableCell>
                    <TableCell fontWeight={600}>Referans</TableCell>
                    <TableCell fontWeight={600} align="right">
                      Fiyat
                    </TableCell>
                    <TableCell fontWeight={600}>Açıklama</TableCell>
                    <TableCell fontWeight={600}>Durum</TableCell>
                    <TableCell fontWeight={600} align="center">
                      İşlemler
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fiyatListesi.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                        <Typography color="textSecondary">
                          Henüz fiyat tanımlanmamış
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    fiyatListesi.map((fiyat) => (
                      <TableRow key={fiyat.Id} hover>
                        <TableCell>{getFiyatTipiLabel(fiyat.FiyatTipi)}</TableCell>
                        <TableCell>
                          {fiyat.ReferansId
                            ? getReferansAdi(fiyat.FiyatTipi, fiyat.ReferansId)
                            : "-"}
                        </TableCell>
                        <TableCell align="right">
                          {fiyat.FiyatTipi === "EkKullaniciOrani"
                            ? `${parseFloat(fiyat.Fiyat).toFixed(2)}%`
                            : `${parseFloat(fiyat.Fiyat).toFixed(2)} ₺`}
                        </TableCell>
                        <TableCell>{fiyat.Aciklama || "-"}</TableCell>
                        <TableCell>
                          <Chip
                            label={fiyat.Etkin ? "Aktif" : "Pasif"}
                            color={fiyat.Etkin ? "success" : "default"}
                            size="small"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            size="small"
                            onClick={() => handleOpenFiyatDialog(fiyat)}
                            color="primary"
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteFiyat(fiyat.Id)}
                            color="error"
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {/* Fiyat Ekleme/Düzenleme Dialog */}
          <Dialog
            open={dialogOpen}
            onClose={handleCloseFiyatDialog}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              {editingFiyat ? "Fiyat Düzenle" : "Yeni Fiyat Ekle"}
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>Fiyat Tipi</InputLabel>
                    <Select
                      value={formData.FiyatTipi}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          FiyatTipi: e.target.value,
                          ReferansId: "",
                        })
                      }
                      label="Fiyat Tipi"
                    >
                      {fiyatTipleri.map((tip) => (
                        <MenuItem key={tip} value={tip}>
                          {getFiyatTipiLabel(tip)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {(formData.FiyatTipi === "Paket" ||
                  formData.FiyatTipi === "Modul") && (
                  <Grid item xs={12}>
                    <FormControl fullWidth required>
                      <InputLabel>
                        {formData.FiyatTipi === "Paket" ? "Paket" : "Modül"}
                      </InputLabel>
                      <Select
                        value={formData.ReferansId}
                        onChange={(e) =>
                          setFormData({ ...formData, ReferansId: e.target.value })
                        }
                        label={
                          formData.FiyatTipi === "Paket" ? "Paket" : "Modül"
                        }
                      >
                        {(formData.FiyatTipi === "Paket" ? paketler : moduller).length === 0 ? (
                          <MenuItem disabled>
                            {formData.FiyatTipi === "Paket"
                              ? "Paketler yükleniyor..."
                              : "Modüller yükleniyor..."}
                          </MenuItem>
                        ) : (
                          (formData.FiyatTipi === "Paket" ? paketler : moduller).map(
                            (item) => (
                              <MenuItem key={item.Id} value={item.Id}>
                                {formData.FiyatTipi === "Paket"
                                  ? item.Adi
                                  : item.ProgramAdi}
                              </MenuItem>
                            )
                          )
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={
                      formData.FiyatTipi === "EkKullaniciOrani"
                        ? "Oran (%)"
                        : "Fiyat (₺)"
                    }
                    type="number"
                    value={formData.Fiyat}
                    onChange={(e) =>
                      setFormData({ ...formData, Fiyat: e.target.value })
                    }
                    required
                    inputProps={{ min: 0, step: 0.01 }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Açıklama"
                    value={formData.Aciklama}
                    onChange={(e) =>
                      setFormData({ ...formData, Aciklama: e.target.value })
                    }
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseFiyatDialog} startIcon={<Cancel />}>
                İptal
              </Button>
              <Button
                onClick={handleSaveFiyat}
                variant="contained"
                startIcon={<Save />}
                sx={{
                  bgcolor: "#00A7B5",
                  "&:hover": { bgcolor: "#008B98" },
                }}
              >
                Kaydet
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}

      {/* Cari bilgileri – Teklif indir öncesi. Yeni lisans: cari kaynağı sorulur; Yıllık yenileme: sadece form (müşteri ana ekrandan seçildi). */}
      <Dialog open={cariDialogOpen} onClose={() => setCariDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Cari / Müşteri Bilgileri</DialogTitle>
        <DialogContent>
          {teklifTipi === "yillikYenileme" ? (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Yıllık yenileme teklifi – cari bilgileri kontrol edip düzenleyebilirsiniz.
            </Typography>
          ) : (
            <>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Önce cari kaynağını seçin. Müşteri seçerseniz listeden arayıp seçebilirsiniz.
          </Typography>
          <FormControl component="fieldset" sx={{ mb: 2 }}>
            <FormLabel component="legend">Cari Kaynağı</FormLabel>
            <RadioGroup
              row
              value={teklifCariKaynagi}
              onChange={(e) => {
                const v = e.target.value;
                setTeklifCariKaynagi(v);
                if (v === "potansiyel") {
                  setSelectedMusteri(null);
                  setMusteriQuery("");
                  setMusteriOptions([]);
                  setCariForm({ ...bosCariForm });
                } else if (v !== "musteri") {
                  setSelectedMusteri(null);
                  setMusteriQuery("");
                  setMusteriOptions([]);
                }
              }}
            >
              <FormControlLabel value="potansiyel" control={<Radio />} label="Potansiyel Müşteri" />
              <FormControlLabel value="musteri" control={<Radio />} label="Müşteri" />
            </RadioGroup>
          </FormControl>

          {teklifCariKaynagi === "musteri" && (
            <>
              <Autocomplete
                options={musteriOptions}
                loading={musteriLoading}
                value={selectedMusteri}
                inputValue={musteriQuery}
                onInputChange={(_, v) => setMusteriQuery(v)}
                onChange={(_, v) => {
                  setSelectedMusteri(v);
                  if (v) {
                    const yetkili = (v.Yetkili || "").trim();
                    const parts = yetkili ? yetkili.split(" ") : [];
                    setCariForm({
                      unvan: v.Unvan || "",
                      vergiDairesi: v.VergiDairesi || "",
                      vergiNo: v.VergiNo || "",
                      tcKimlikNo: v.TCKimlikNo || "",
                      adi: parts[0] || "",
                      soyadi: parts.slice(1).join(" ") || "",
                      email: v.EPosta || "",
                      telefon: v.Tel || "",
                      adresFatura: v.Adres || "",
                    });
                  }
                }}
                getOptionLabel={(o) => {
                  if (!o) return "";
                  const unvan = o.Unvan || o.unvan || "";
                  const vergiNo = o.VergiNo || o.vergiNo || "";
                  const musteriNo = o.MusteriNo || o.musteriNo || "";
                  return `${unvan}${musteriNo ? " (" + musteriNo + ")" : ""}${vergiNo ? " - " + vergiNo : ""}`;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Müşteri Ara (Unvan / Vergi No / Müşteri No)"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {musteriLoading ? <CircularProgress color="inherit" size={18} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                    sx={{ mb: 2 }}
                  />
                )}
              />
            </>
          )}
          </>
          )}

          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Firma Ünvanı"
                value={cariForm.unvan}
                onChange={(e) => setCariForm({ ...cariForm, unvan: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Vergi Dairesi"
                value={cariForm.vergiDairesi}
                onChange={(e) => setCariForm({ ...cariForm, vergiDairesi: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Vergi No (10 hane)"
                value={cariForm.vergiNo}
                onChange={(e) => setCariForm({ ...cariForm, vergiNo: e.target.value.replace(/\D/g, "").slice(0, 10) })}
                placeholder="Şirket vergi no"
                inputProps={{ maxLength: 10 }}
                helperText={
                  teklifTipi === "yeniTeklif" && teklifCariKaynagi === "potansiyel" && cariForm.vergiNo && cariForm.vergiNo.replace(/\D/g, "").length !== 10
                    ? "10 haneli olmalıdır"
                    : ""
                }
                error={teklifTipi === "yeniTeklif" && teklifCariKaynagi === "potansiyel" && !!cariForm.vergiNo && cariForm.vergiNo.replace(/\D/g, "").length !== 10}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="TC Kimlik No (11 hane)"
                value={cariForm.tcKimlikNo}
                onChange={(e) => setCariForm({ ...cariForm, tcKimlikNo: e.target.value.replace(/\D/g, "").slice(0, 11) })}
                placeholder="Bireysel TC no"
                inputProps={{ maxLength: 11 }}
                helperText={
                  teklifTipi === "yeniTeklif" && teklifCariKaynagi === "potansiyel" && cariForm.tcKimlikNo && cariForm.tcKimlikNo.replace(/\D/g, "").length !== 11
                    ? "11 haneli olmalıdır"
                    : ""
                }
                error={teklifTipi === "yeniTeklif" && teklifCariKaynagi === "potansiyel" && !!cariForm.tcKimlikNo && cariForm.tcKimlikNo.replace(/\D/g, "").length !== 11}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: -1, mb: 0 }}>
                Potansiyel müşteri için Vergi No veya TC Kimlik No'dan en az biri zorunludur.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Yetkili Adı"
                value={cariForm.adi}
                onChange={(e) => setCariForm({ ...cariForm, adi: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Yetkili Soyadı"
                value={cariForm.soyadi}
                onChange={(e) => setCariForm({ ...cariForm, soyadi: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="E-posta"
                type="email"
                value={cariForm.email}
                onChange={(e) => setCariForm({ ...cariForm, email: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Telefon"
                value={cariForm.telefon}
                onChange={(e) => setCariForm({ ...cariForm, telefon: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Adres (Fatura)"
                value={cariForm.adresFatura}
                onChange={(e) => setCariForm({ ...cariForm, adresFatura: e.target.value })}
                multiline
                rows={2}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCariDialogOpen(false)}>İptal</Button>
          <Button
            variant="contained"
            onClick={handleTeklifPdfSubmit}
            disabled={
              pdfIndirLoading ||
              (teklifTipi === "yeniTeklif" && teklifCariKaynagi === "musteri" && !selectedMusteri) ||
              (teklifTipi === "yeniTeklif" &&
                teklifCariKaynagi === "potansiyel" &&
                (() => {
                  const v = (cariForm.vergiNo || "").replace(/\D/g, "");
                  const t = (cariForm.tcKimlikNo || "").replace(/\D/g, "");
                  return !(v.length === 10 || t.length === 11);
                })())
            }
            startIcon={pdfIndirLoading ? <CircularProgress size={18} /> : <PictureAsPdf />}
            sx={{ bgcolor: "#00A7B5", "&:hover": { bgcolor: "#008B98" } }}
          >
            {pdfIndirLoading ? "Hazırlanıyor..." : "Teklifi Aç / Yazdır"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FiyatHesaplama;
